import React, { useState } from 'react';
import { Send } from 'lucide-react';
import { toast } from 'sonner';
import { api, errText } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';

export function Composer({ convId, windowOpen, onSent }) {
  const [text, setText] = useState('');
  const [busy, setBusy] = useState(false);

  const send = async () => {
    setBusy(true);
    try {
      await api.post(`/whatsapp/conversations/${convId}/send`, { body: text });
      setText('');
      onSent();
    } catch (e) {
      toast.error(errText(e, 'No se pudo enviar'));
    } finally {
      setBusy(false);
    }
  };

  if (!windowOpen) {
    return (
      <div className="border-t border-[hsl(var(--border))] p-4 text-xs text-[hsl(var(--muted-foreground))]" data-testid="whatsapp-composer-closed">
        La ventana de 24 h está cerrada: WhatsApp solo permite escribir primero con una plantilla aprobada (desde Despliegues Ministeriales). Cuando la persona responda, podrás escribir libremente.
      </div>
    );
  }
  return (
    <div className="border-t border-[hsl(var(--border))] p-3 flex gap-2 items-end" data-testid="whatsapp-composer">
      <Textarea rows={2} placeholder="Escribe una respuesta…" value={text} onChange={(e) => setText(e.target.value)}
        onKeyDown={(e) => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); if (text.trim() && !busy) send(); } }}
        data-testid="whatsapp-composer-input" />
      <Button onClick={send} disabled={busy || !text.trim()} data-testid="whatsapp-composer-send"><Send className="h-4 w-4" /></Button>
    </div>
  );
}
